import gql from 'graphql-tag';

const UPDATE_SUB_DEVICE_TYPE = gql`
  mutation Mutation(
    $deviceSerialNo: String!
    $deviceType: String!
    $hardwareVersion: Int!
    $deviceTypeName: String
    $subType: String
    $subTypeName: String
  ) {
    updateSubDeviceType(
      deviceSerialNo: $deviceSerialNo
      deviceType: $deviceType
      hardwareVersion: $hardwareVersion
      deviceTypeName: $deviceTypeName
      subType: $subType
      subTypeName: $subTypeName
    ) {
      code
      sensors
    }
  }
`;

export default UPDATE_SUB_DEVICE_TYPE;
